export default __webpack_public_path__ + "static/media/workshop5.b9cd651e.jpg";